module.exports = __webpack_public_path__ + "static/media/spoonerism-task (12).124ad946.mp3";